import { useState } from "react";

import {
  ExternalContainer,
  InternalContainer,
} from "../../../../components/Reusable/Layout";
import { DGCoinTable, DGCoinSearchFilter } from "./component";
import { CreateDGCoinModal } from "../../Modal/DGCoins/CreateDGCoinModal";
import { DGCoinProps } from "./types";
import { DGCoinPlan } from "../../../../features/auth/store/types/dgcoin-types";
import { DeleteDGCoinModal } from "../../Modal/DGCoins/DeleteDGCoinModal";
import { EditDGCoinModal } from "../../Modal/DGCoins/EditDGCoinModal";

const DGCoin: React.FC<DGCoinProps> = ({
  dgcoinPlans,
  loading,
  statusFilter,
  setStatusFilter,
  onDGCoinPlanClick,
  searchTerm,
  setSearchTerm,
}) => {
  const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [selectedDGCoinPlan, setSelectedDGCoinPlan] = useState<
    undefined | DGCoinPlan
  >(undefined);
  const [dgCoinPlanId, setDGCoinPlanId] = useState<number | null>(null);

  const onEditClick = (data: DGCoinPlan) => {
    setSelectedDGCoinPlan(data);
    setIsEditModalOpen(true);
  };

  const onDeleteClick = (id: number) => {
    setDGCoinPlanId(id);
    setIsDeleteModalOpen(true);
  };

  return (
    <ExternalContainer>
      <div className="h-screen dark:bg-[#FFFFFF1A] w-[1030px]">
        <InternalContainer headerText="DG Coin Plans">
          <div className="flex flex-col">
            <DGCoinSearchFilter
              onStatusFilter={setStatusFilter}
              searchTerm={searchTerm}
              onSearchChange={setSearchTerm}
              onCreateNewProduct={() => setIsCreateModalOpen(true)}
            />
            <div className="border border-[#FFFFFF1A]">
              <DGCoinTable
                dgcoinPlans={dgcoinPlans}
                statusFilter={statusFilter}
                onDGCoinPlanClick={onDGCoinPlanClick}
                onDeleteClick={onDeleteClick}
                onEditClick={onEditClick}
                loading={loading}
              />
            </div>
          </div>
        </InternalContainer>
        <CreateDGCoinModal
          isOpen={isCreateModalOpen}
          onClose={() => setIsCreateModalOpen(false)}
        />
        <EditDGCoinModal
          dgCoinPlan={selectedDGCoinPlan}
          isOpen={isEditModalOpen && selectedDGCoinPlan !== undefined}
          onClose={() => {
            setIsEditModalOpen(false);
            setSelectedDGCoinPlan(undefined);
          }}
        />
        <DeleteDGCoinModal
          id={dgCoinPlanId}
          isOpen={isDeleteModalOpen && dgCoinPlanId !== null}
          onClose={() => {
            setIsDeleteModalOpen(false);
            setDGCoinPlanId(null);
          }}
        />
      </div>
    </ExternalContainer>
  );
};

export default DGCoin;
